import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

// import AdSlot from "./adSlot";
import Banner from "./banner";
import TrendingNow from "./trending";
// import Trending3D from "./trending3D";
import Trending3D from "./trending3D-1";
import SearchBar from "./searchbar";
import NationalPlate from "./nationalplate";
import { TrendingHottestItem } from "../shared/type";
import { imagesList } from "../dataLists/cityImagesList";
import { Stores } from "../dataLists/index";
import { regionLabel } from "../i18n/display";
import { getTrendingData } from "../services/getTrendingData";

const PCTemplate: React.FC = () => {
  const { t } = useTranslation();
  const heroText = "Discover the Best TCG Stores Near You.";
  const [isShowTrending, setIsShowTrending] = useState(false);
  const [isShowSearch, setIsShowSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [trendingData, setTrendingData] = useState<TrendingHottestItem[]>([]);

  const loadTrendingData = async () => {
    try {
      const parsedData = await getTrendingData();
      setTrendingData(parsedData);
    } catch (error) {
      console.error("Error fetching trending data:", error);
      setTrendingData([]);
    }
  };

  useEffect(() => {
    if (windowWidth < 1170) {
      setIsShowTrending(true);
    }
  }, [windowWidth]);

  useEffect(() => {
    loadTrendingData();
  }, []);

  useEffect(() => {
    let currentIndex = 0;
    const typingInterval = window.setInterval(() => {
      currentIndex += 1;
      // setTypedHeroText(heroText.slice(0, currentIndex));

      if (currentIndex >= heroText.length) {
        window.clearInterval(typingInterval);
      }
    }, 80);

    return () => window.clearInterval(typingInterval);
  }, [heroText]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filteredImagesList = useMemo(() => {
    const keyword = searchValue.trim().toLowerCase();
    if (!keyword) return imagesList;

    const matchedPrefectures = new Set(
      Stores.filter((item) => {
        const nationMatched = (item.nation ?? "")
          .toLowerCase()
          .includes(keyword);
        const prefecture = item.prefecture ?? "";
        const prefectureMatched =
          prefecture.toLowerCase().includes(keyword) ||
          regionLabel(t, prefecture).toLowerCase().includes(keyword);
        const tagMatched = item.tags.some((tag) =>
          (tag ?? "").toLowerCase().includes(keyword),
        );
        const shopNameMatched = (item.title ?? "")
          .toLowerCase()
          .includes(keyword);
        return (
          nationMatched || prefectureMatched || tagMatched || shopNameMatched
        );
      }).map((item) => item.prefecture?.toLowerCase()),
    );

    return imagesList.filter((item) =>
      matchedPrefectures.has(item.prefecture.toLowerCase()),
    );
  }, [searchValue, t]);
  const showNoResultMessage =
    searchValue.trim().length > 0 && filteredImagesList.length === 0;

  return (
    <main className="w-full min-h-screen flex flex-col overflow-x-hidden">
      <section className="pb-[1px] overflow-x-hidden">
        <div className="relative bg-gray-0 overflow-x-hidden">
          <Banner />
          {/* content */}
          <div className="absolute top-[50%] right-10 translate-y-[-50%] bg-black bg-opacity-0 z-10">
            <TrendingNow
              trendingData={trendingData.slice(0, 10)}
              className="hidden md:block"
            />
          </div>
        </div>
      </section>
      {/* <AdSlot id="ad_home_below_banner" className="w-full" /> */}
      <section className="md:hidden bg-[#181818]/0 flex justify-center items-center w-full px-8 pt-5 overflow-visible">
        <Trending3D
          trendingData={trendingData.slice(0, 10)}
          className="block md:hidden w-full"
          isShow={isShowTrending}
        />
      </section>
      <section className="w-full h-full flex justify-center items-center">
        <article className="w-full max-w-[1600px] md:px-14 md:py-14 p-8 pt-0 flex flex-col justify-center items-center gap-y-8">
          <div
            className="w-full flex justify-between"
            style={{
              flexDirection:
                isShowSearch && windowWidth < 800 ? "column" : "row",
              // justifyContent:
              //   windowWidth < 800 ? "space-between" : "space-between",
              alignItems: windowWidth < 800 ? "flex-start" : "flex-center",
            }}
          >
            <h1 className="text-xl md:text-2xl font-bold text-[#1d1d1d] capitalize">
              {t("home.findingCardShops")}
            </h1>

            <SearchBar
              isShowSearch={isShowSearch}
              setIsShowSearch={setIsShowSearch}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
            />
          </div>
          {showNoResultMessage ? (
            <div className="w-full py-24 flex justify-center items-center rounded-xl border border-[#F05A2A]/30 bg-[#F05A2A]/5 text-[#1d1d1d] text-base md:text-xl font-medium">
              {t("allRegions.noResults")}
            </div>
          ) : (
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-x-8 gap-y-10">
              {filteredImagesList.map((item) => (
                // <div
                //   key={item.prefecture}
                //   className="w-full flex justify-center"
                // >
                <NationalPlate key={item.prefecture} props={item} />
                // </div>
              ))}
            </div>
          )}
        </article>
      </section>
    </main>
  );
};

export default PCTemplate;
